module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Content_TagsFilter":{"handleWom.changeNavi.widget":[{"value":"@this","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101003},"path":"~.Content_TagsFilter","_fox_":1}],"handleWom.changeNavi.event":[{"value":"activate","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Content_TagsFilter","_fox_":1}],"handleWom.changeNavi.callback":[{"value":function () {
var
tags = fox.Navigator.get('tags'),
parent = this.getParent(),
pager = parent.wom1('#pager'),
navPrefix
;
if (pager && pager.navPrefix && fox.Navigator.get(pager.navPrefix)) {
return false;
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101022},"path":"~.Content_TagsFilter","_fox_":1}],"hooks.onStopInit":[{"value":function (argument) {
var parent = this.getParent();
var dl = parent.wom1('#dl');
var pager = parent.wom1('#pager');
var tagsFilter = parent.wom1('#tagsFilter');
this.handleEvent(fox.site.wom1('#navi'), 'modified_tags', function (val, navi, ev) {
var pagerPrefix = pager.navPrefix;
if (pagerPrefix && fox.Navigator.get(pagerPrefix)) {
var hash = fox.Navigator.getAll();
delete hash[pagerPrefix];
fox.Navigator.update(hash, true);
}
parent.applyTagsFilter(tagsFilter.getTagsFromNavigator());
if (dl._loadStatus == 'loading') {
dl.abort();
}
dl.load();
});
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101042},"path":"~.Content_TagsFilter","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/content/tagsfilter.js
// module id = 658
// module chunks = 4